// import React,{useState} from 'react';


const useAuthStatus=(token)=>{
  // const [status,setStatus]=useState(false);
  return !!token;
}

export default useAuthStatus;